// extracted by mini-css-extract-plugin
export default {"qrCodeDialog":"QRCodeDialog_qrCodeDialog__5LMco"};